module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("chat-message-single " + (_vm.isLocal ? 'local-message' : ''))
  }, [_c('div', {
    staticClass: "chat-message-header"
  }, [_c('span', {
    staticClass: "chat-message-username"
  }, [_vm._v(_vm._s(_vm.username))]), _vm._v(" "), _c('span', {
    staticClass: "chat-message-time"
  }, [_vm._v(_vm._s(_vm.time))])]), _vm._v(" "), _c('div', {
    staticClass: "bubble-container"
  }, [(_vm.canBeDeleted) ? _c('div', {
    staticClass: "chat-bin"
  }, [_c('div', {
    on: {
      "click": _vm.deleteMessage
    }
  }, [_c('span', {
    staticClass: "delete-chat-message"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.chatBubbleCssClass,
    style: ({
      backgroundColor: _vm.messageBubbleColor
    })
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.linkedContent)
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cff7828"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/Message.vue
// module id = 362
// module chunks = 1